import { api } from '@/lib/api'
import type { FormSchema } from '@/features/contract/types'
import type { Gate } from '@/features/contract/gating/types'
import type { ContractElement } from './types'

/** Element stage gate (which FIELD requirements are met for advancing the element's stage). */
export async function getElementGate(contractId: number, elementId: number): Promise<Gate> {
  const r = await api.get<Gate>(`/api/contracts/${contractId}/elements/${elementId}/gate`)
  return r.data
}

/** Form schema (sections + fields + placements) for an element's product (object_type='product'). */
export async function getProductFormSchema(productCode: string): Promise<FormSchema> {
  const r = await api.get<FormSchema>(`/api/forms/product/${productCode}`)
  return r.data
}

export async function updateElementSection(
  contractId: number,
  elementId: number,
  sectionCode: string,
  extras: Record<string, unknown>,
): Promise<ContractElement[]> {
  const r = await api.patch<ContractElement[]>(
    `/api/contracts/${contractId}/elements/${elementId}/sections/${sectionCode}`,
    { extras },
  )
  return r.data
}

export async function listContractElements(contractId: number): Promise<ContractElement[]> {
  const r = await api.get<ContractElement[]>(`/api/contracts/${contractId}/elements`)
  return r.data
}

export async function completeElementStage(contractId: number, elementId: number): Promise<ContractElement[]> {
  const r = await api.post<ContractElement[]>(`/api/contracts/${contractId}/elements/${elementId}/complete-stage`)
  return r.data
}

export async function overrideElementStage(
  contractId: number,
  elementId: number,
  targetStageCode: string,
): Promise<ContractElement[]> {
  const r = await api.post<ContractElement[]>(
    `/api/contracts/${contractId}/elements/${elementId}/override-stage`,
    { targetStageCode },
  )
  return r.data
}
